module.exports = __webpack_public_path__ + "static/our-team-background-35b7161ec7c40bf82d8f95939f124530.svg";